"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    drawerHeaderNavigationClassNames: function() {
        return drawerHeaderNavigationClassNames;
    },
    useDrawerHeaderNavigationStyles_unstable: function() {
        return useDrawerHeaderNavigationStyles_unstable;
    }
});
const _react = require("@griffel/react");
const drawerHeaderNavigationClassNames = {
    root: 'fui-DrawerHeaderNavigation'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__resetStyles)("rfs9jc2", "r4yk2e8", [
    ".rfs9jc2{margin-top:calc(var(--spacingVerticalS) * -1);margin-right:calc(var(--spacingHorizontalL) * -1);margin-bottom:calc(var(--spacingVerticalS) * -1);margin-left:calc(var(--spacingHorizontalL) * -1);}",
    ".r4yk2e8{margin-top:calc(var(--spacingVerticalS) * -1);margin-left:calc(var(--spacingHorizontalL) * -1);margin-bottom:calc(var(--spacingVerticalS) * -1);margin-right:calc(var(--spacingHorizontalL) * -1);}"
]);
const useDrawerHeaderNavigationStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(drawerHeaderNavigationClassNames.root, styles, state.root.className);
    return state;
}; //# sourceMappingURL=useDrawerHeaderNavigationStyles.styles.js.map
